import styled from "styled-components";

const ImageSmallPreview = styled.img`
  width: 290px;
  height: 120px;
`;

export default ImageSmallPreview;
